<template>
  <div class="d-flex flex-column align-center justify-center py-4">
    <VProgressCircular indeterminate color="primary" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UserService from '@/services/user-service/user.service';

export default {
  name: 'logoutPage',
  methods: {
    ...mapActions('main', ['startLoading', 'stopLoading', 'showSnackbar']),
    ...mapActions('user', ['logOutUser']),
    async sendLogout() {
      try {
        await UserService.logoutUser();
      } catch (err) {
        this.showSnackbar({ text: err.message });
      } finally {
        this.logOutUser();
        this.$router.push({ name: 'Login' });
        this.stopLoading();
      }
    }
  },
  mounted() {
    this.startLoading();
    this.sendLogout();
  }
};
</script>
